import React, {Fragment, useEffect, useState} from 'react';
import Tabs from 'react-responsive-tabs';
import Users from "./Users";
import Organization from "./Organization";
import LegacyUsers from "../LegacySettings/LegacyUsers";
import LegacyOrganization from "../LegacySettings/LegacyOrganization";
import LegacySubscription from "../LegacySettings/LegacySubscription";
import BillingInfo from "./Billing";
import PaymentHistory from "../PaymentHistory";
import {useStepsContext} from "../../Subscription/context/stepsContext";
import {getPaymentInfo,getSessionValue,getAccessedFormsFromProfile, removeLastChar} from "../../../Common/Appcommon";
import requestApi from '../../../services/requestApi.service';
import GeneralSettings from '../General';

const Accounts = props => {

    let [selectedTab,setSelectedTab] = useState(0);
    const [customerPaymentType, setCustomerPaymentType] = useState("");
    let [defaultSelectedTab,setDefaultSelectedTab] = useState(props.defaultSelectedTab);
    const formid = props.formid !== undefined && props.formid !== null ? props.formid : "";
    const isNewSubscription = process.env.REACT_APP_IS_NEW_PAYMENT === "true" ? true : false;
    const tabInfo = {
        'users' : 0,
        'organization' : 1,
        'subscription' : 2,
        'billing' : 3,
        'generalsettings' : 4
    };
    let [modifiedTabs,setModifiedTabs] = useState([{}]);
    useEffect(() => {
        if( defaultSelectedTab !== undefined && tabInfo[defaultSelectedTab] !== undefined){
            setSelectedTab(tabInfo[defaultSelectedTab]);
        }
        (async () => {
            const data = await getPaymentInfo();
            //prefill the current pricing details in states.
            const paymentTypeBySubId = data.length > 0 ? data[data.length - 2] : "Online";
            setCustomerPaymentType(paymentTypeBySubId               );
            getProfileAccessedFormTabs(paymentTypeBySubId);

        })();
    },[])

    /*const tabsContent = [
        {
            title: 'Users',
            content: <Users formid={props.formid} formname={props.formname} action={props.action}/>
        },
        {
            title: 'Organization Details',
            content: <Organization key={Math.random()} />
        }
    ];*/
    const generalSettings = {
        title: 'General Settings',
        content: <GeneralSettings />,
        formname : 'generalsettings',
    };
    const tabsContent = [
        {
            title: 'Users',
            content: <LegacyUsers formid={formid} />,
            formname: 'table_6'
        },
        {
            title: 'Organization',
            content: <LegacyOrganization />,
            formname: 'table_21'
        }
        // {
        //     title: 'Subscription',
        //     content: <BillingInfo />,
        //      formname: 'payment1'
        // },
        // {
        //     title: 'Payments',
        //     content: <PaymentHistory />,
        //        formname: 'payment2'
        // }
    ];

    if(!isNewSubscription && customerPaymentType !== "Offline"){
        tabsContent[2] = {
            title: 'Subscription',
            content: <BillingInfo />,
            formname: 'payment1'
        };
    }

    if(customerPaymentType !== "Offline" && isNewSubscription){
        tabsContent[2] = {
            title: 'Subscription',
            content: <BillingInfo />,
            formname: 'payment1'
        };
        tabsContent[3] = {
            title: 'Payments',
            content: <PaymentHistory />,
            formname: 'payment2'
        } 
    }

    const offlineTabsContent = [
        {
            title: 'Users',
            content: <LegacyUsers formid={formid} />,
            formname: 'table_6'
        },
        {
            title: 'Organization',
            content: <LegacyOrganization />,
            formname: 'table_21'
        },
    ];

    async function getProfileAccessedFormTabs(customertype = "") {
        let tabList = "";
        tabsContent.map((forms, index) => {
            tabList += forms['formname']+",";
        });
        tabList = removeLastChar(tabList);
        let responce = await getAccessedFormsFromProfile(tabList);
        if(responce.issuccess){
            let modifiedTab = [];
            let data = responce.data;
            data.map((forms, indexs) => {
                if(customertype === "Offline"){
                    offlineTabsContent.map((tab, index) => {
                        if(tab.formname === data[indexs] ){
                            modifiedTab.push(tab);
                        }
                    })
                }else{
                    tabsContent.map((tab, index) => {
                        if(tab.formname === data[indexs] ){
                            modifiedTab.push(tab);
                        }
                    })
                }
            })
            if(customertype !== "Offline" && tabsContent[2] !== undefined &&  tabsContent[3] !== undefined){
                modifiedTab.push(tabsContent[2]);
                modifiedTab.push(tabsContent[3]);
            }
            if(getSessionValue('loginusername') === "sadmin"){
                modifiedTab.push(generalSettings);
            }
            setModifiedTabs(modifiedTab);
        }
    }

    function getTabs() {
       /* if(customerPaymentType === "Offline"){
            return offlineTabsContent.map((tab, index) => ({
                title: tab.title,
                getContent: () => tab.content,
                key: index,
            }));
        } else {*/
            return modifiedTabs.map((tab, index) => ({
                title: tab.title,
                getContent: () => tab.content,
                key: index,
            }));
        //}
    }

    return (
        <Fragment>
            <Tabs
                tabsWrapperClass="body-tabs body-tabs-layout header-tab-padding"
                transform={false}
                showInkBar={true}
                selectedTabKey={selectedTab}
                items={getTabs()}/>
        </Fragment>
    )
}

export default Accounts;
